import React from 'react';
import './dot-flashing.scss';

function DotFlashingLoading(props) {
    const { leftAndAbove } = props;
    return <div className={leftAndAbove ? 'dot-flashing dot-flashing-left-and-above' : 'dot-flashing'}></div>;
}

export default DotFlashingLoading;
